import classNames from 'clsx';
import React from 'react';

import type { HGPokerGameTile } from '@swf/core/types/Poker';

import styles from './Tags.scss';

interface Props {
  tags: HGPokerGameTile['tags'];
}

const Tags: React.FC<Props> = ({ tags }) => (
  <div className={classNames(styles.tags, 'tags')}>
    {tags.map(({ title, color }) => (
      <div key={title} className={classNames(styles.tag, styles[color])}>
        {title}
      </div>
    ))}
  </div>
);

export default Tags;
